// extracted by mini-css-extract-plugin
module.exports = {"preloaderDotted":"preloaderDotted__4uvi9","absolute":"absolute__74S57","fixed":"fixed__RmPE+","animation":"animation__7iFel","flashing":"flashing__9OJ78"};